webpackJsonp([93719862385932],{

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/landscape-maintenance.57bb3279.jpg";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _landscapeDevelopment = __webpack_require__(28);
	
	var _landscapeDevelopment2 = _interopRequireDefault(_landscapeDevelopment);
	
	var _landscapeMaintenance = __webpack_require__(127);
	
	var _landscapeMaintenance2 = _interopRequireDefault(_landscapeMaintenance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LandscapeMaintenance = function LandscapeMaintenance() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'landscape maintenance | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _landscapeDevelopment2.default, alt: 'landscape maintenance project' })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Landscape Maintenance'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We offer a wide range of custom solutions.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'col' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        ),
	        ' > ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services' },
	          'Services'
	        ),
	        ' > Landscape Maintenance'
	      ),
	      _react2.default.createElement('img', { src: _landscapeMaintenance2.default, alt: 'landscape maintenance project from ICE enterprises' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Landscape maintenance is a mostly commercial solution that aims to maintain and improve. The state of your landscape speaks wonders about the state of the company or individuals residing on the property.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Family Landscaping'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We\u2019re a family owned company that goes a step further than the competitor because we have more invested in every project. Because of this we can offer specialized maintenance solutions that are tailored to a specific projects needs.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Maintenance at every level'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'One of our most popular solutions is the general maintenance solution. This includes premium fertilization, weeding, mowing, mulching and more. We offer the general solution on a monthly basis vs. the one time payment for specialized maintenance solutions.'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us today and learn more'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	};
	
	exports.default = LandscapeMaintenance;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-landscape-maintenance-js-0ea9ef9ea8129e50355d.js